import axios from 'axios';
import { authHeaders } from './authHeaders';

const API_URL = '/api/auth';

export interface LoginResponse {
  success: boolean;
  user?: string;
  role?: string;
  /** Token de la sesión; se manda en cada llamada a la API. */
  token?: string;
  error?: string;
}

export interface VerifyResponse {
  success: boolean;
  user?: {
    username: string;
    role: string;
  };
  error?: string;
}

const authService = {
  /**
   * Intenta autenticar al usuario
   * @param username - Nombre de usuario
   * @param password - Contraseña
   * @returns Respuesta de autenticación
   */
  async login(username: string, password: string): Promise<LoginResponse> {
    try {
      const response = await axios.post(`${API_URL}/login`, {
        username,
        password
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as LoginResponse;
      }
      return {
        success: false,
        error: 'Error de conexión con el servidor'
      };
    }
  },

  /**
   * Verifica que la sesión guardada siga valiendo y el usuario esté activo
   * @returns Información del usuario de la sesión
   */
  async verifySession(): Promise<VerifyResponse> {
    try {
      const response = await axios.get(`${API_URL}/me`, { headers: authHeaders() });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as VerifyResponse;
      }
      return {
        success: false,
        error: 'Error de conexión con el servidor'
      };
    }
  }
};

export default authService;
